import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL;
const API_KEEPER = import.meta.env.VITE_API_KEEPER;

const CortexService = {
    search: async (plate) => axios.post(API_URL + `/cortexSearch/search`, plate).then(({data}) => data.data).catch((err) => { throw err }),

    renavamSearch: async (formData) => axios.post(API_URL + "/cortexRenavam/search", formData).then(({data}) => data).catch((err) => { throw err }),

    personDataByCpf: async (cpf) => axios.get(API_KEEPER + "/cortex/personDataByCpf/" + cpf).catch((err) => { throw err }),
 };

export default CortexService;